<template>
  <div
    class="tw-mb-4 tw-inline-flex tw-flex-col tw-bg-white tw-p-6 tw-rounded-lg tw-border tw-border-primary-grey-100 tw-w-full"
  >
    <div class="tw-border-b tw-border-primary-grey-100 tw-pb-8 tw-px-4">
      <p class="tw-text-2xl tw-font-semibold">
        {{ t("connections") }}
      </p>
      <p class="tw-text-xl">
        {{ t("connections-panel") }}
      </p>
    </div>
    <div class="tw-pt-10 tw-pb-4 tw-px-4 tw-flex tw-gap-4">
      <div class="tw-flex tw-items-center tw-gap-2 tw-mr-4">
        <span
          v-if="isM365Connected"
          class="tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-shrink-0 tw-rounded-full tw-border tw-border-system-success-500 tw-bg-system-success-50"
        >
          <CbIconTick color="#65C091" />
        </span>
        <span
          v-else
          class="tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-shrink-0 tw-text-sm tw-font-medium tw-rounded-full tw-border tw-border-primary-grey-200 tw-bg-primary-grey-50"
          >1</span
        >
        {{ t("connect-microsoft-365") }}
      </div>
      <div
        v-if="showNdrJournalSteps"
        class="tw-flex tw-items-center tw-gap-2 tw-mr-4"
      >
        <span
          v-if="isNdrConfigured"
          class="tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-shrink-0 tw-rounded-full tw-border tw-border-system-success-500 tw-bg-system-success-50"
        >
          <CbIconTick color="#65C091" />
        </span>
        <span
          v-else
          class="tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-shrink-0 tw-text-sm tw-font-medium tw-rounded-full tw-border tw-border-primary-grey-200 tw-bg-primary-grey-50"
          >2</span
        >
        {{ t("step-create-ndr") }}
      </div>
      <div
        v-if="showNdrJournalSteps"
        class="tw-flex tw-items-center tw-gap-2 tw-mr-4"
      >
        <span
          v-if="isJournalRuleConfigured"
          class="tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-shrink-0 tw-rounded-full tw-border tw-border-system-success-500 tw-bg-system-success-50"
        >
          <CbIconTick color="#65C091" />
        </span>
        <span
          v-else
          class="tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-shrink-0 tw-text-sm tw-font-medium tw-rounded-full tw-border tw-border-primary-grey-200 tw-bg-primary-grey-50"
          >3</span
        >
        {{ t("step-configure-journaling-rule") }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CbIconTick } from "@/components/cybersentriq-ui";
import { useI18n } from "vue-i18n";

interface ConnectionsCardProps {
  isM365Connected: boolean;
  isNdrConfigured: boolean;
  isJournalRuleConfigured: boolean;
  showNdrJournalSteps: boolean;
}
const { t } = useI18n();
defineProps<ConnectionsCardProps>();
</script>
